import { DepositDocumentFragment, ReservationDetailFragment } from 'src/api/api.generated'
import { DepositF } from '../types/reservation-detail.types'

export function getDepositsF(reservation: ReservationDetailFragment | null | undefined, documents: DepositDocumentFragment[] | null | undefined): DepositF[] | null | undefined {
  if (reservation === null) {
    return null
  }
  if (reservation === undefined) {
    return undefined
  }
  if (documents === null) {
    return null
  }
  if (documents === undefined) {
    return undefined
  }

  return documents
}
